import { ButtonProps } from '../model';

const Button = ({
  onClickFn,
  btnType,
  btnText,
  customCss,
  isDisable = false,
  toolTipText,
}: ButtonProps) => {
  return (
    <div>
      <div className="relative group inline text-left">
        {toolTipText && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:flex flex-col items-center z-50">
            <div className="relative px-4 py-2 text-sm text-white bg-brand-800 dark:bg-brand-700 rounded-lg shadow-lg">
              {toolTipText}
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-3 h-3 bg-gray-800 dark:bg-brand-700 rotate-45 z-[-1]" />
            </div>
          </div>
        )}
        <button
          onClick={onClickFn}
          type={btnType}
          disabled={isDisable}
          className={
            customCss ??
            `
      flex w-full justify-center rounded-md
      bg-brand-600 px-3 py-1.5 text-sm font-semibold text-white
      shadow hover:bg-brand-700 dark:hover:bg-brand-500
      focus-visible:outline-none focus-visible:ring-4
      focus-visible:ring-brand-300 dark:focus-visible:ring-brand-500
    `
          }
        >
          {btnText}
        </button>
      </div>
    </div>
  );
};

export default Button;
